import { createDecorator } from 'vscode/vscode/vs/platform/instantiation/common/instantiation';

const IExternalTerminalService = ( createDecorator('externalTerminal'));

export { IExternalTerminalService };
